import React from 'react';
import { Tab, Tabs } from '@blueprintjs/core';
import PageLockHOC from 'hoc/compNull';
import { connect } from 'react-redux';

import styled from 'styled-components';
import Clearfix from 'components/elements/clearfix';
import BiodiversityDetail from './BiodiversityDetail';
import { getOne } from 'api/biodiversityApi';
import slug from 'constants/slug';
import SpeciesManagement from './SpeciesManagement';

const HeaderContainer = styled.div`
  font-size: 18px;
`;

@connect((state) => ({
  permissions: state.permissions,
}))
@PageLockHOC(['biodiversity.view'])
export default class BiodiversityView extends React.Component {
  static propTypes = {};
  constructor(props) {
    super(props);
    this.state = {
      tabActive: props.tabActive,
      biodiversity: {},
    };
  }

  panelList = [
    {
      key: 'Detail',
      title: 'Chi tiết dự án',
      permissionRole: 'biodiversity.view',
    },
    {
      key: 'SpeciesInfo',
      title: 'Thông tin loài',
      permissionRole: 'biodiversity.view',
    },
  ];

  async componentDidMount() {
    const { match, history } = this.props;
    const biodiversityID = match.params._id;

    const results = await getOne(biodiversityID);
    if (!results.data) history.push(slug.BIODIVERSITY.LIST);

    this.setState({ biodiversity: results.data });
  }

  renderPanel = (keyPanel) => {
    const { biodiversity } = this.state;
    const { history, match, location } = this.props;

    switch (keyPanel) {
      case 'Detail': {
        return (
          <BiodiversityDetail
            initialValue={biodiversity}
            BiodiversityID={match.params._id}
            history={history}
          />
        );
      }
      case 'SpeciesInfo': {
        return (
          <SpeciesManagement
            match={match}
            location={location}
            history={history}
            key={biodiversity._id}
            dataList={biodiversity.Species}
            biodiversityID={match.params._id}
          />
        );
      }
      default:
        return null;
    }
  };

  handleTabChange = (tabActive) => {
    const { history, match } = this.props;
    const biodiversityID = match.params._id;
    this.setState({ tabActive });
    if (tabActive === 'SpeciesInfo')
      history.replace(
        slug.BIODIVERSITY.DETAIL_WITH_ID + biodiversityID + '/species'
      );
    if (tabActive === 'Detail')
      history.replace(slug.BIODIVERSITY.DETAIL_WITH_ID + biodiversityID);
  };

  render() {
    const { biodiversity, tabActive } = this.state;

    return (
      <div>
        <HeaderContainer>Tên dự án: {biodiversity.ProjectName}</HeaderContainer>
        <Clearfix height={16} />
        <Tabs onChange={this.handleTabChange} selectedTabId={tabActive} animate={false}>
          {this.panelList.map((item) => {
            return (
              <Tab
                id={item.key}
                key={item.key}
                title={item.title}
                panel={this.renderPanel(item.key)}
              />
            );
          })}
        </Tabs>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Biodiversity/BiodiversityView/index.js